module.exports = __webpack_public_path__ + "img/on.89931462.svg";